import * as z from 'zod';
import { CACHE_DURATION, deleteContent, safeGetItem, safeSetItem } from '@shared/cache/cache.browser';
import type { TileItem } from '@tilelist/domain/composition/TileListitem.ts';

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const SCROLL_POSITION = 'reptile.scrollPosition';

export const scrollPositionSchema = z.preprocess(
    (value) => {
        if (!value) return null;

        if (typeof value === 'string') {
            try {
                return JSON.parse(value);
            } catch {
                return null;
            }
        }

        return value;
    },
    z.object({
        save: z.string(),
        listPosition: z.string(),
        timestamp: z.string().regex(/^\d+$/),
        url: z.string(),
    }),
);

type ScrollPositionCache = z.infer<typeof scrollPositionSchema>;

function getCurrentUrl(): string {
    return location.href.replace(location.hash, '');
}

function getCurrentMinutes(): number {
    return Math.floor(new Date().getTime() / 1000 / 60);
}

async function clearScrollPositionCache(): Promise<void> {
    await deleteContent(SCROLL_POSITION);
}

async function getScrollPositionCache(): Promise<ScrollPositionCache | null> {
    const cacheStr = await safeGetItem(SCROLL_POSITION);
    const parsed = scrollPositionSchema.safeParse(cacheStr);

    if (!parsed.success) return null;

    const currentMinutes = getCurrentMinutes();
    const currentUrl = getCurrentUrl();
    const savedTimestamp = Number.parseInt(parsed.data.timestamp, 10);

    const timeValid = currentMinutes - savedTimestamp <= CACHE_DURATION;
    const urlValid = parsed.data.url === currentUrl;

    return timeValid && urlValid ? parsed.data : null;
}

export async function updateScrollPosition(item: TileItem) {
    const cache: ScrollPositionCache = {
        save: `${item.product.id}`,
        listPosition: `${item.localListPosition}`,
        timestamp: `${getCurrentMinutes()}`,
        url: getCurrentUrl(),
    };

    await safeSetItem(SCROLL_POSITION, JSON.stringify(cache));
}

export async function restoreScrollPosition() {
    const cache = await getScrollPositionCache();
    const productTile = cache
        ? document.querySelector(`[data-product-id="${cache.save}"][data-local-list-position="${cache.listPosition}"]`)
        : null;

    if (productTile) {
        /**
 *
 *
 *
 *
 *
 *
 */
        setTimeout(() => {
            productTile.scrollIntoView();
        });
    }

    await clearScrollPositionCache();
}
